/***************************************************************
6/9/2017
Alexander Self
Timesheet Edit
- Allows supervisors and managers to edit exisiting timesheets
***************************************************************/
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import EmployeeList from '../../employee_list';
import { AutoComplete } from '../../inputs';
import TimesheetDeleteModal from './timesheet_delete_modal';
import { fetchTimesheetsToDelete, deleteTimesheet } from '../../../actions';
import { mapEmployeeForAutoComplete, findEmployeeByName, onDummyComplete } from '../../../utils';
const TimesheetDelete = ({ selectedEmployee, employees, myEmployees, submitter, payPeriodStartDate, payPeriodEndDate,
  timesheets, fetchTimesheetsToDelete, deleteTimesheet }) => {
  return (
    <div className="row">
      <blockquote>
        <span className="flow-text">Delete Timesheet: {"\u00a0"} { selectedEmployee.firstName ?
          <b>{selectedEmployee.firstName} {selectedEmployee.lastName}</b> : ''
        }
        </span>
      </blockquote>
      <div className="col s12 m12 l2">
      <AutoComplete id={'employee-delete-ts-list'} label={'Find Employee'}
        data={mapEmployeeForAutoComplete(employees)}
        onComplete={(val, id) => onDummyComplete(val, id)} />
        <button className="btn waves-light waves-effect"
          onClick={(val, id) => {
            fetchTimesheetsToDelete(findEmployeeByName(document.getElementById('employee-delete-ts-list').value, employees), { payPeriodStartDate, payPeriodEndDate });
            document.getElementById('employee-delete-ts-list').value = '';
          }}>
          Fetch
        </button>
        <div className="emp-list">
          <div className="card">
            <EmployeeList employees={myEmployees} onClick={(e) => fetchTimesheetsToDelete(e, { payPeriodStartDate, payPeriodEndDate })}
              icon={'add'} header={'Select Employee'} _class={'green'} isEditOrDelete={true}
            />
          </div>
        </div>
      </div>
      <div className="col s12 m12 l10">
        <div className="row">
          <div className="col s12 m12 l12">
            <div className="delete-list">
              { timesheets.length > 0 ?
                timesheets.map((ts) => (
                  <div key={ts.timesheetID} className="delete-item">
                    <button data-target={ts.timesheetID}
                      className="btn waves-light waves-effect red rounded">
                      { ts.date.split('T')[0] }
                    </button>
                    <TimesheetDeleteModal id={ts.timesheetID} employee={selectedEmployee}
                      timesheet={ts} deleteTimesheet={deleteTimesheet}
                    />
                  </div>
                )) : 'No Timesheets Available'
              }
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    submitter: state.auth.user.guid,
    employees: state.timesheet.employees,
    myEmployees: state.timesheet.myEmployees,
    selectedEmployee: state.timesheet.delete.employee,
    timesheets: state.timesheet.delete.timesheets,
    payPeriodStartDate: state.misc.payPeriod.startDate,
    payPeriodEndDate: state.misc.payPeriod.endDate
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchTimesheetsToDelete,
    deleteTimesheet
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(TimesheetDelete);


/* END */



// WEBPACK FOOTER //
// ./src/components/timesheets/delete/timesheet_delete.js